import React, { useContext, useRef } from 'react';
import { Platform, StyleSheet, Text } from 'react-native';
import PropTypes from 'prop-types';
import LayoutContext from '../../contexts/Layout';
import { useOverflowStyle } from '../../hooks/useOverflowStyle';

const H3 = ({ dataSet, numberOfLines = 1, style, text, ...rest }) => {
    const { layout } = useContext(LayoutContext);
    const ref = useRef();
    const overflowStyle = useOverflowStyle(ref, layout.styleGuide.h3);

    return (
        <Text
            {...rest}
            adjustsFontSizeToFit={true}
            dataSet={{
                tagName: 'H3',
                fontFamily: layout.styleGuide.h3.fontFamily,
                condensedFontFamily: layout.styleGuide.h3.condensedFontFamily,
                fontSize: layout.styleGuide.h3.fontSize,
                color: layout.styleGuide.h3.color,
                ...dataSet
            }}
            numberOfLines={numberOfLines}
            ref={ref}
            style={StyleSheet.flatten([Style.h3, layout.styleGuide.h3, overflowStyle, style])}
        >
            {text}
        </Text>
    );
};

const Style = StyleSheet.create({
    h3: {
        color: '#000',
        fontFamily: 'GothamBook',
        fontSize: Platform.OS.equals('web') ? '21pt' : 21
    }
});

H3.propTypes = {
    text: PropTypes.string.isRequired
};

export default H3;
